import React, { useState, useContext, useMemo } from 'react';
import "./projectspage.css";
import Page from "../../Utilities/Page";
import Card from '../../Utilities/Card';
import Icons from '../../Utilities/Icons';
import FilterBar from '../../Utilities/FilterBar';
import DataContext from '../../../DataContext';

const ProjectsPage = () => {

  const { projects } = useContext(DataContext);
  const [search, setSearch] = useState("");
  const [type, setType] = useState("");
  const [tech, setTech] = useState("");

  const types = useMemo(() => {
    const found = new Set();

    projects.forEach(project => {
      if (project.data.type) found.add(project.data.type);
    })

    return [...found].sort();
  }, [projects])

  const techs = useMemo(() => {
    const found = new Set();

    projects.forEach(project => {
      const stack = project.data.projectStack;

      if (stack) {
        Object.keys(stack).forEach(key => {
          if (stack[key]) found.add(key);
        })
      }
    })

    return [...found].sort();
  }, [projects])

  const shown = useMemo(() => {
    const term = search.trim().toLowerCase();

    return projects.filter(project => {
      const thisProject = project.data;
      const stack = thisProject.projectStack || {};
      const title = thisProject.title || "";

      if (term !== "" && !title.toLowerCase().includes(term)) return false;
      if (type !== "" && thisProject.type !== type) return false;
      if (tech !== "" && !stack[tech]) return false;

      return true;
    })
  }, [projects, search, type, tech])

  return (
    <Page cls='projects-page fcs' title="Projects | Chai Cheng Xun" >
      <div className="page-wrap">
        <div className="cmd"><span className="prompt">$</span> ls ~/projects</div>
        <div className="d-title">Projects</div>
        <div className="d-text intro">Things I have built, from web apps to security tooling.</div>
        <FilterBar
          placeholder='Search projects...'
          search={search}
          setSearch={setSearch}
          filters={[
            { label: "Type", options: types, value: type, onChange: setType },
            { label: "Tech", options: techs, value: tech, onChange: setTech }
          ]}
          shown={shown.length}
          total={projects.length}
        />
        <div className="card-grid">
          {
            shown.map(project => {
              const thisProject = project.data;
              const image = thisProject.mobileIMG || {};
              /* real records carry empty strings for the sizes they lack */
              const thumb = image.desktop || image.tablet || image.mobile || "";

              return (
                <Card
                  key={project.id}
                  layout='stack'
                  to={thisProject.projectURL || ""}
                  media={<div className='media'>{thumb && <img src={thumb} alt={thisProject.title} />}</div>}
                  title={thisProject.title}
                  meta={thisProject.type}
                  description={thisProject.overview}
                  footer={<Icons cls='fcs' {...thisProject.projectStack} />}
                />
              )
            })
          }
        </div>
        {
          projects.length > 0 && shown.length === 0 &&
          <div className="d-text empty">No projects match that filter.</div>
        }
      </div>
    </Page>
  )
}

export default ProjectsPage
